const autoNgTemplateLoaderTemplate1 = require('./volumesDatatable.html');

angular.module('portainer.kubernetes').component('kubernetesVolumesDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesVolumesDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    removeAction: '<',
    refreshCallback: '<',
  },
});
